/**
 * Подпись о возрасте данных (docs/10-design.md).
 *
 * Правило: приложение никогда не говорит, что данные свежее, чем они есть.
 * Поэтому в шапке отражается худший источник, а не время открытия страницы.
 */
import type { Freshness } from '@/api/hooks';
import { formatRelative } from './format';

/** Дольше этого молчать об источнике нельзя: он явно отстал. */
const STALE_AFTER_MS = 2 * 60 * 60 * 1000;

export function freshnessLabel(data: Freshness | undefined, now: Date = new Date()): string {
  if (!data) return 'Проверяем, когда собирались данные';

  if (data.failing.length > 0) {
    const names = data.failing.map((item) => item.title).join(', ');
    return `Синхронизация падает: ${names}`;
  }

  if (!data.newestAt) return 'Данные ещё не собирались';

  const oldest = data.oldest;
  if (oldest?.lastSuccessAt) {
    const age = now.getTime() - new Date(oldest.lastSuccessAt).getTime();
    // Один отставший источник важнее общей свежести: о нём и говорим.
    if (age > STALE_AFTER_MS) {
      return `${oldest.title}: обновлялись ${formatRelative(oldest.lastSuccessAt, now)}`;
    }
  }

  return `Данные обновлены ${formatRelative(data.newestAt, now)}`;
}
